// GraphQL documents for the Ledger Loader screen. Field names mirror
// tp_server src/apollo-server/schema/ledgerloader.gql.
import gql from "graphql-tag";

export const FLOWS = gql`
  query ledgerloader_flows {
    ledgerloader_flows {
      name
      files {
        name
        table
      }
      required
      reservation
      allowed_dateformats
      default_dateformat
      max_payload_bytes
    }
  }
`;

export const PREVIEW = gql`
  mutation ledgerloader_preview(
    $flow: String
    $files: [ledgerloader_file_input]
    $dateformat: String
    $controls: [ledgerloader_control_input]
  ) {
    ledgerloader_preview(
      flow: $flow
      files: $files
      dateformat: $dateformat
      controls: $controls
    ) {
      ok
      flow
      fingerprint
      files {
        file
        table
        rows
        columns_kept
        columns_stripped
        substitutions
        trailing_empty_rows_stripped
        columns
        rows_json
        rows_total
        rows_truncated
        counter_column
      }
      issues {
        severity
        code
        file
        row
        column
        message
        detail
      }
      issues_total
      issues_truncated
      issue_summary {
        code
        file
        column
        count
      }
      duplicate_of_batchid
      duplicate_of_created_by
      duplicate_of_created_at
      sequence_name
      sequence_current
      provisional_range_start
      provisional_range_end
      provisional_note
      assigned {
        count
        entry_column
        entry_start
        entry_end
        ref_column
        journal_start
        journal_end
        ref_start
        ref_end
        indicative
        note
      }
    }
  }
`;

export const COMMIT = gql`
  mutation ledgerloader_commit(
    $flow: String
    $files: [ledgerloader_file_input]
    $fingerprint: String
    $dateformat: String
    $controls: [ledgerloader_control_input]
  ) {
    ledgerloader_commit(
      flow: $flow
      files: $files
      fingerprint: $fingerprint
      dateformat: $dateformat
      controls: $controls
    ) {
      ok
      batchid
      fingerprint
      flow
      rows_inserted
      range_start
      range_end
      sequence_set_to
      files {
        file
        table
        rows
        columns_kept
        columns_stripped
        substitutions
        trailing_empty_rows_stripped
        columns
        rows_json
        rows_total
        rows_truncated
        counter_column
      }
      issues {
        severity
        code
        file
        row
        column
        message
        detail
      }
      issues_total
      issues_truncated
      issue_summary {
        code
        file
        column
        count
      }
      assigned {
        count
        entry_column
        entry_start
        entry_end
        ref_column
        journal_start
        journal_end
        ref_start
        ref_end
        indicative
        note
      }
    }
  }
`;

export const BATCHES = gql`
  query ledgerloader_batches(
    $limit: Int
    $fingerprint: String
    $before_id: String
    $flow: String
    $created_by: String
  ) {
    ledgerloader_batches(
      limit: $limit
      fingerprint: $fingerprint
      before_id: $before_id
      flow: $flow
      created_by: $created_by
    ) {
      id
      fingerprint
      flow
      files {
        file
        rows
      }
      range_start
      range_end
      sequence_set_to
      rows_inserted
      created_by
      created_at
      assigned {
        count
        entry_column
        entry_start
        entry_end
        ref_column
        journal_start
        journal_end
        ref_start
        ref_end
        indicative
        note
      }
    }
  }
`;

// The fingerprint lookup is the same BATCHES query called with { fingerprint }
// only. Exported under its own name so call sites read clearly.
export const BATCH_BY_FINGERPRINT = BATCHES;
